import { useContext } from 'react';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useDeviceToken = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const createDeviceToken = async deviceType => {
    try {
      // Get the temporary token from AuthContext
      const tempToken = authCtx.tempToken;
      if (!tempToken) {
        throw new Error('Kein temporärer Token gefunden. Bitte melde dich erneut an.');
      }

      const result = await sendRequest({
        url: '/api/v1/auth/device-token',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tempToken}`,
        },
        body: {
          deviceType: deviceType,
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  const loginWithDeviceToken = async deviceToken => {
    try {
      const tempToken = authCtx.tempToken;
      if (!tempToken) {
        throw new Error('Kein temporärer Token gefunden. Bitte melde dich erneut an.');
      }

      return await sendRequest({
        url: '/api/v1/auth/device-token/login',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tempToken}`,
          'Device-Token': deviceToken,
        },
        body: {},
      });
    } catch (error) {
      throw error;
    }
  };

  return {
    createDeviceToken,
    loginWithDeviceToken,
    isLoading,
    error,
  };
};

export default useDeviceToken;
